import React, { useEffect, useState } from 'react';
import Input from 'antd/es/input/Input';
import moment from 'moment';
import { DAYTIME_FORMAT, DAY_FORMAT, ORDER_TYPE } from '../../../constants';
import BaseTable from '../Base';
import isEmpty from 'lodash/isEmpty';
import filter from 'lodash/filter';
import { ReactSVG } from 'react-svg';
const RouteAddOrdersTable = ({ dataSource, isFetching, pagination, ...props }) => {
  const [searchedRiders, setSearchedRiders] = useState(dataSource || []);
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    setSearchedRiders(dataSource);
  }, [dataSource]);

  useEffect(() => {
    let orderT = dataSource;
    if (!isEmpty(searchValue)) {
      orderT = filter(dataSource, (order) => {
        return (
          order.orderId?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          order?.region?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          order?.orderRef?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          order.orderType?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          order.pickupName?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          order.pickupAddress?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          order.pickupPhone?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          order.deliveryName?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          order.deliveryAddress?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          order.deliveryPhone?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          order.load?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          order.status?.toString().toLowerCase().match(searchValue.toLowerCase())
        );
      });
    }
    setSearchedRiders(orderT);
  }, [searchValue]);

  const handleOnSearch = (e) => {
    setSearchValue(e.target.value);
  };
  const columns = [
    {
      title: 'Order ID',
      dataIndex: 'orderId',
      key: 'orderId',
      fixed: 'left',
      width: 150,
    },
    {
      title: 'Order Ref',
      dataIndex: 'orderRef',
      key: 'orderRef',
      width: 150,
    },
    {
      title: 'Region',
      dataIndex: 'region',
      key: 'region',
    },
    {
      title: 'Order Type',
      dataIndex: 'orderType',
      key: 'orderType',
      width: 120,
      render: (value) => {
        return (
          <div className={value + ' orderType'}>
            {' '}
            <ReactSVG className="icon" src={'/icons/' + value + '.svg'} /> {ORDER_TYPE[value]}
          </div>
        );
      },
    },
    {
      title: 'Delivery Date',
      dataIndex: 'deliveryDate',
      key: 'deliveryDate',
      render: (value) => {
        return value ? moment(value).format(DAY_FORMAT) : '';
      },
    },
    {
      title: 'Company',
      key: 'Company',
      className: 'order-companies',
      render: (row) => {
        if (row.location?.company) {
          return (
            <div>
              <div className="logo">
                <img src={row.location?.company?.logoThumbUrl || row.location?.company?.logoUrl} />
              </div>
              {row.location?.company?.name}
            </div>
          );
        }
      },
    },
    {
      title: 'Pickup Name',
      dataIndex: 'pickupName',
      key: 'pickupName',
    },
    {
      title: 'Pickup Address',
      dataIndex: 'pickupAddress',
      width: 500,
      key: 'pickupAddress',
    },
    {
      title: 'Pickup Phone',
      dataIndex: 'pickupPhone',
      key: 'pickupPhone',
    },
    {
      title: 'Pickup Time Window',
      dataIndex: 'Pickup Time Window',
      key: 'Pickup Time Window',
      render: (value, row) => {
        return (row.pickupTimeStart || '') + ' - ' + (row.pickupTimeEnd || '');
      },
    },
    {
      title: 'Delivery Name',
      dataIndex: 'deliveryName',
      key: 'deliveryName',
    },
    {
      title: 'Delivery Address',
      dataIndex: 'deliveryAddress',
      key: 'deliveryAddress',
      width: 500,
    },
    {
      title: 'Delivery Phone',
      dataIndex: 'deliveryPhone',
      key: 'deliveryPhone',
    },
    {
      title: 'Delivery Time Window',
      dataIndex: 'Delivery Time Window',
      key: 'Delivery Time Window',
      render: (value, row) => {
        return (row.deliveryTimeStart || '') + ' - ' + (row.deliveryTimeEnd || '');
      },
    },
    {
      title: 'Load',
      dataIndex: 'load',
      key: 'load',
    },
    {
      title: 'Updated At',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      render: (value) => {
        return value ? moment(value).format(DAYTIME_FORMAT) : '';
      },
    },
    {
      title: 'Status',
      dataIndex: 'status',
      fixed: 'right',
      width: 100,
      key: 'status',
      render: (value) => {
        return <span className={'status orders ' + value.toLowerCase()}>{value?.split('_').join(', ')}</span>;
      },
    },
    {
      dataIndex: 'tags',
      fixed: 'right',
      width: 100,
      key: 'tags',
      render: (tags) => {
        return (
          <div className="tags">
            {tags?.length > 0 &&
              tags.map((tag) => {
                return <div key={tag.id + 'label'} className="label" style={{ background: '#' + tag.color }}></div>;
              })}
          </div>
        );
      },
    },
  ];

  return (
    <div className="RouteAddOrdersTable table-common">
      <div className="riders-header table-header">
        <div className="search">
          <Input
            onChange={handleOnSearch}
            placeholder="Search"
            suffix={<img src="/icons/search.svg" />}
            disabled={isFetching}
            value={searchValue}
          />
        </div>
      </div>
      <BaseTable
        columns={columns}
        pagination={pagination}
        scroll={{ x: 3500 }}
        dataSource={searchedRiders}
        rowClassName={(record, index) => (index % 2 === 0 ? 'table-row-dark' : 'table-row-light')}
        {...props}
      />
    </div>
  );
};

export default RouteAddOrdersTable;
